import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AbsenceDrawerHelperService {
  private isAbsenceDrawerVisibleSubject = new BehaviorSubject(false);
  private selectedAbsenceIdSubject = new BehaviorSubject('');

  public isAbsenceDrawerVisible$ =
    this.isAbsenceDrawerVisibleSubject.asObservable();
  public selectedAbsenceId$ = this.selectedAbsenceIdSubject.asObservable();

  toggleAbsenceDrawer(isVisible: boolean): void {
    this.isAbsenceDrawerVisibleSubject.next(isVisible);
  }

  setSelectedAbsenceId(id: string): void {
    this.selectedAbsenceIdSubject.next(id);
  }
}
